/**
 * 보호소 메모 창이 "지금 보고 있는 것"을 알기 위한 공용 상태
 * - 동물 상세·입양신청서 상세가 열릴 때 setMemoAnimal / setMemoRequest, 닫힐 때 clear
 * - 메모 창은 이 값으로 [이 동물/신청서에 연결] 체크를 미리 켬
 */
import { reactive } from 'vue';

export const memoContext = reactive({
    animal: null,     //{ notify_number, animal_name }
    request: null,    //{ idx, applicant, notify_number }
});

export function setMemoAnimal(a) { memoContext.animal = a && a.notify_number ? { notify_number: a.notify_number, animal_name: a.animal_name || '' } : null; }
export function clearMemoAnimal(notify) { if (!notify || (memoContext.animal && memoContext.animal.notify_number == notify)) memoContext.animal = null; }
export function setMemoRequest(r) { memoContext.request = r && r.idx ? { idx: r.idx, applicant: r.applicant || '', notify_number: r.notify_number || '' } : null; }
export function clearMemoRequest(idx) { if (!idx || (memoContext.request && memoContext.request.idx == idx)) memoContext.request = null; }
